import React from 'react';

function ShortlistTableNote() {
    return (
        <p className="shortlistTableNote">
            NOTE<br />
            Progeny in bold are stakes placed.<br />
            Click on progeny to view lifetime record.<br />
            Data incorporates all racing in UK and Ireland, races at all Paris tracks in France,
            all Group races in Europe and Grade 1 races worldwide since 1988.
            Some other races abroad may also be included.
        </p>
    );
}

export default ShortlistTableNote;



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/ShortlistTableNote.js